











































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { USER_CENTER_URL } from '@/apps/open/constants'
import { logout } from '@/apps/open/services/user'
import { IUserInfo } from '@/apps/open/store/modules/user/types'
import { goLogin, goApply } from '@/apps/open/utils'

@Component({
  methods: {
    goLogin
  }
})
export default class Header extends Vue {
  @Prop()
  companyList!: any[]

  get authClass () {
    return this.isPending ? 'authing' : this.isPassed ? 'authed' : 'unauth'
  }

  get authText () {
    return this.isPending ? '认证中' : this.isPassed ? '已认证' : '未认证'
  }

  get isPending () {
    return this.curEnterprise && this.curEnterprise.status === 0
  }

  get isPassed () {
    return this.curEnterprise && this.curEnterprise.status === 1
  }

  get allEnterpriseList () {
    return this.$store.getters['User/developerList']
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  get isHome () {
    return this.$route.name === 'home' || this.$route.name === 'case-detail'
  }

  get isAppCenter () {
    return this.$route.name === 'app-center'
  }

  get isLogin () {
    return this.$store.getters['User/isLogin']
  }

  get userDevelopers () {
    return this.$store.getters['User/userInfo'].developers || []
  }

  get userInfo () {
    const userInfo = this.$store.getters['User/userInfo']
    return userInfo
  }

  get isDeveloper () {
    return this.$store.getters['User/isDeveloper']
  }

  get isDoc () {
    return this.$route.path.indexOf('/docs') > -1
  }

  get isAdminCenter () {
    return this.$route.path.indexOf('/developer-info') === 0 ||
      this.$route.path.indexOf('/app-info') === 0 ||
      this.$route.path.indexOf('/weboffice') === 0 ||
      this.$route.path.indexOf('/admin-users') === 0 ||
      this.$route.path.indexOf('/format-conversion') === 0 ||
      this.$route.path.indexOf('/ai-admin') === 0
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  selectEnterprise (selectedEnterprise: any) {
    this.handleSelectEnterprise(selectedEnterprise)
  }

  async handleSelectEnterprise (selectedEnterprise: any) {
    if (selectedEnterprise) {
      if (selectedEnterprise.developer_id) {
        this.$store.commit('User/SET_CUR_ENTERPRISE', selectedEnterprise)
        this.$eventBus.$emit('changeEnterprise')
        this.goApply(this.$route.path)
      } else if (!selectedEnterprise.developer_id && selectedEnterprise.id) {
        this.$store.commit('User/SET_CUR_ENTERPRISE', selectedEnterprise)
        this.$router.push({ name: 'app-access' })
      }
    }
  }

  goApply (curPath?: string) {
    goApply('', false, curPath)
  }

  toHome () {
    this.$router.replace({ name: 'home' })
  }

  goDoc () {
    this.$router.replace({ name: 'doc' })
  }

  toDeveloper () {
    this.$router.push({ name: 'developer-info' })
  }

  handleCommand (command: string) {
    switch (command) {
      case 'a':
        window.open(USER_CENTER_URL)
        break
      case 'b':
        this.logout()
        break
    }
  }

  logout () {
    this.$store.dispatch('User/LOGOUT')
    this.$store.commit('Plussvr/SET_ENTERPRISE_LIST', [])
  }
}
